<template>
    <div class="pim-page">
        <div class="page-header">
            <h1>{{ $t('menu.pim.page.header') }}</h1>
            <p class="page-subtitle">{{ $t('menu.pim.page.subtitle') }}</p>
        </div>

        <div class="hub-grid">
            <div class="tap-hub-card" @click="$router.push({ name: 'pim-products-pricing' })" style="animation-delay: 0.05s;">
                <div class="hub-icon">
                    <i class="bx bx-dollar-circle"></i>
                </div>
                <div class="hub-title">{{ $t('menu.pim.subpages.productsPricing.header') }}</div>
                <div class="hub-desc">{{ $t('menu.pim.subpages.productsPricing.desc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>

            <div class="tap-hub-card" @click="$router.push({ name: 'pim-products-content' })" style="animation-delay: 0.1s;">
                <div class="hub-icon" style="background: rgba(237, 106, 90, 0.1); border-color: rgba(237, 106, 90, 0.15);">
                    <i class="bx bx-edit" style="color: #ED6A5A;"></i>
                </div>
                <div class="hub-title">{{ $t('menu.pim.subpages.productsContent.header') }}</div>
                <div class="hub-desc">{{ $t('menu.pim.subpages.productsContent.desc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>

            <div class="tap-hub-card" @click="$router.push({ name: 'pim-products-filter' })" style="animation-delay: 0.15s;">
                <div class="hub-icon" style="background: rgba(247, 203, 21, 0.1); border-color: rgba(247, 203, 21, 0.15);">
                    <i class="bx bx-filter-alt" style="color: #F7CB15;"></i>
                </div>
                <div class="hub-title">{{ $t('menu.pim.subpages.productsFilter.header') }}</div>
                <div class="hub-desc">{{ $t('menu.pim.subpages.productsFilter.desc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>

            <div class="tap-hub-card" @click="$router.push({ name: 'pim-products-image' })" style="animation-delay: 0.2s;">
                <div class="hub-icon" style="background: rgba(126, 91, 239, 0.1); border-color: rgba(126, 91, 239, 0.15);">
                    <i class="bx bx-image-alt" style="color: #7e5bef;"></i>
                </div>
                <div class="hub-title">{{ $t('menu.pim.subpages.productsImage.header') }}</div>
                <div class="hub-desc">{{ $t('menu.pim.subpages.productsImage.desc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();
        user.getProductsPim();

        return { user }
    },
    methods: {

    }
}
</script>

<style scoped>
.page-header {
    margin-bottom: 2rem;
}
.page-subtitle {
    color: #9aa0a8;
    font-size: 0.875rem;
    margin-top: 0.125rem;
}

.hub-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1rem;
}
.hub-grid .tap-hub-card {
    animation: slideUp 0.5s ease-out both;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
}
</style>
